import React, { useContext } from "react";
import { Card, CardBody, CardTitle, CardText } from "reactstrap";
import { StateContext } from "../utils/context";
import { Trans } from "react-i18next";

const UserWelcome = () => {
  const { currentUser } = useContext(StateContext);
  const { first_name, parent_company, is_sub_user } = currentUser;

  return (
    <Card>
      <CardBody>
        {Object.keys(currentUser).length > 0 && (
          <>
            <CardTitle>
              <Trans
                i18nKey="dashboard.view.message.userWelcomeTitle"
                values={{ firstName: first_name }}
              >
                Hey {first_name}, welcome back to Music Link Platform.
              </Trans>
            </CardTitle>
            <CardText>
              {is_sub_user && (
                <Trans i18nKey="dashboard.view.message.ownedAndManaged" values={{ parent_company: parent_company }}>
                  Your account is owned and managed by <b>{ parent_company }</b>,
                  visit our <a href="/help"><b>Help Page</b></a> to learn more.
                </Trans>
              )}
            </CardText>
          </>
        )}
      </CardBody>
    </Card>
  );
};

export default UserWelcome;
